import AppRouter from "./routes/AppRouter";

export default function App() {
  return <AppRouter />;
}
